import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 text-lg font-heading text-background-50 mb-4 whitespace-nowrap">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-full text-base">
                🍑
              </span>
              桃桃漫画
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              桃桃漫画网提供韩国漫画无删减下拉式服务，免费可爱风韩漫在线阅读，下拉操作轻松，畅享无删减韩国可爱漫画。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-heading text-background-100 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#featured" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  热门推荐
                </a>
              </li>
              <li>
                <a href="#latest" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  最新更新
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-heading text-background-100 mb-4">分类导航</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-heading text-background-100 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@taotao-comic.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-line text-primary-400"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 桃桃漫画网 TaotaoComic.com - 韩国漫画无删减下拉式阅读平台 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}